import {BvToast} from 'bootstrap-vue/src/components/toast'
import FlashMessageTypeEnum from '@js/enums/FlashMessageTypeEnum';
import {VNode, VNodeChildren} from 'vue/types/vnode';
import PropertyErrorsInterface from '@form/validation/PropertyErrorsInterface';
import {CreateElement} from 'vue/types/vue';

export default class FlashMessenger {
  private toaster: BvToast | null = null;

  public addError(message: string): void {
    this.add(message, FlashMessageTypeEnum.ERROR, true, 'Fehler');
  }

  public addErrorsAsWarning(errors: PropertyErrorsInterface[], createElement: CreateElement): void {
    const messages: VNodeChildren = [];
    errors.forEach((error) => {
      messages.push(error.title)
      messages.push(createElement('br'))
    });
    this.add(createElement('span', {}, messages), FlashMessageTypeEnum.WARNING, false, 'Achtung');
  }

  public addFromResponse(flashMessage: any): void {
    switch (flashMessage.type) {
      case FlashMessageTypeEnum.ERROR:
        this.addError(flashMessage.message);
        break;
      case FlashMessageTypeEnum.INFO:
        this.addInfo(flashMessage.message);
        break;
      case FlashMessageTypeEnum.SUCCESS:
        this.addSuccess(flashMessage.message);
        break;
      case FlashMessageTypeEnum.WARNING:
        this.addWarning(flashMessage.message);
        break;
      default:
        throw new Error(`Unknown flash message type: ${flashMessage.type}`);
    }
  }

  public addInfo(message: string): void {
    this.add(message, FlashMessageTypeEnum.INFO, false, 'Information');
  }

  public addLegacyUploadErrorsAsWarning(
    errorMessages: Record<string, Record<string, string>>,
    createElement: CreateElement
  ): void {
    const messages: VNodeChildren = [];
    for (const elementName of Object.values(errorMessages)) {
      for (const message of Object.values(elementName)) {
        messages.push(message)
        messages.push(createElement('br'))
      }
    }
    this.add(createElement('span', {}, messages), FlashMessageTypeEnum.WARNING, false, 'Achtung');
  }

  public addSuccess(message: string, sticky = false): void {
    this.add(message, FlashMessageTypeEnum.SUCCESS, sticky, 'Erfolg');
  }

  public addWarning(message: string): void {
    this.add(message, FlashMessageTypeEnum.WARNING, false, 'Achtung');
  }

  public setToaster(toaster: BvToast): void {
    this.toaster = toaster;
  }

  private add(message: string | VNode, type: FlashMessageTypeEnum, sticky: boolean, title: string): void {
    if (!this.toaster) {
      return;
    }
    this.toaster.toast(
      message,
      {
        title: title,
        variant: type,
        noAutoHide: sticky,
      }
    );
  }
}
